import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { useQuery } from '@tanstack/react-query'
import { Search, UserMinus } from 'lucide-react'
import { chatService } from '../../services/chatService'
import { avatarGradient, initials } from '../crm/pipeline/tokens'

// Mesajı birine atama seçici (ClickUp "Assign a message")
export default function AssignPopover({ company, x, y, current, onPick, onClose }) {
  const ref = useRef(null)
  const [q, setQ] = useState('')
  const [pos, setPos] = useState({ left: x, top: y })
  const { data } = useQuery({
    queryKey: ['chat-users', company], queryFn: () => chatService.searchUsers(company), staleTime: 300000,
  })
  const users = data?.data?.users || []
  const list = useMemo(() => {
    const t = q.trim().toLocaleLowerCase('tr')
    return users.filter((u) => !t || (u.display_name || '').toLocaleLowerCase('tr').includes(t)).slice(0, 8)
  }, [users, q])

  useLayoutEffect(() => {
    const el = ref.current; if (!el) return
    const r = el.getBoundingClientRect()
    let left = x, top = y
    if (left + r.width > window.innerWidth - 8) left = Math.max(8, window.innerWidth - r.width - 8)
    if (top + r.height > window.innerHeight - 8) top = Math.max(8, y - r.height - 12)
    setPos({ left, top })
  }, [x, y])

  useEffect(() => {
    const onDown = (e) => { if (ref.current && !ref.current.contains(e.target)) onClose?.() }
    const onKey = (e) => { if (e.key === 'Escape') { e.stopPropagation(); onClose?.() } }
    document.addEventListener('mousedown', onDown, true)
    document.addEventListener('keydown', onKey, true)
    return () => { document.removeEventListener('mousedown', onDown, true); document.removeEventListener('keydown', onKey, true) }
  }, [onClose])

  return createPortal(
    <div ref={ref} style={{ left: pos.left, top: pos.top }}
      className="fixed z-[92] w-64 bg-white border border-gray-200 rounded-xl shadow-2xl py-1.5 z-[92]">
      <div className="px-2 pb-1.5">
        <div className="relative">
          <Search size={12} className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-400" />
          <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Kime atansın?"
            className="w-full pl-6.5 pl-7 pr-2 py-1 text-[12px] border border-gray-200 rounded-lg outline-none focus:ring-1 focus:ring-violet-200" />
        </div>
      </div>
      {current && (
        <button onClick={() => { onPick?.(null); onClose?.() }}
          className="w-full flex items-center gap-2 px-3 py-1.5 text-left hover:bg-red-50 text-red-600">
          <UserMinus size={13} /> <span className="text-[12.5px]">Atamayı kaldır</span>
        </button>
      )}
      <div className="max-h-56 overflow-y-auto">
        {list.map((u) => (
          <button key={u.id} onClick={() => { onPick?.(u.id); onClose?.() }}
            className={`w-full flex items-center gap-2 px-3 py-1.5 text-left hover:bg-gray-50 ${String(current) === String(u.id) ? 'bg-violet-50' : ''}`}>
            <span className={`w-6 h-6 rounded-full bg-gradient-to-br ${avatarGradient(u.display_name)} flex items-center justify-center text-[9px] font-semibold text-white`}>
              {initials(u.display_name)}
            </span>
            <span className="text-[12.5px] text-gray-800 truncate flex-1">{u.display_name}</span>
          </button>
        ))}
        {list.length === 0 && <div className="px-3 py-4 text-center text-[11px] text-gray-400">Kullanıcı yok</div>}
      </div>
    </div>,
    document.body,
  )
}
